import { render } from "./NoteContainer.vue?vue&type=template&id=2a4d57f2"
import script from "./NoteContainer.vue?vue&type=script&lang=js"
export * from "./NoteContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__